module.exports = "/images/flechaPedir.svg";